<template>
  <div>
    <h3 class="mt-3 mb-2">
      Edite sua notificação
    </h3>
    <b-card>
      <h5>Utilize as nossas hashtags para inserir algumas informações especificas na sua notificação:</h5>
      <div class="demo-inline-spacing">
        <b-badge
          pill
          variant="primary"
        >
          #primeiro_nome
        </b-badge>
        <b-badge
          pill
          variant="primary"
        >
          #email
        </b-badge>
        <b-badge
          pill
          variant="primary"
        >
          #codigo_pedido
        </b-badge>
        <b-badge
          pill
          variant="primary"
        >
          #link_rastreio
        </b-badge>
        <b-badge
          pill
          variant="primary"
        >
          #codigo_boleto
        </b-badge>
        <b-badge
          pill
          variant="primary"
        >
          #link_boleto
        </b-badge>
        <b-badge
          pill
          variant="primary"
        >
          #pix_qrcode
        </b-badge>
      </div>
    </b-card>
    <b-overlay
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
      :show="show"
    >
      <b-card>
        <div>
          <b-form
            ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain"
          >
            <!-- Row Loop -->
            <b-row
              v-for="(item, index) in items"
              ref="row"
            >
              <!-- Item Name -->
              <b-col md="8">
                <b-row>
                  <b-col
                    v-if="item.notifications !== null"
                    md="12"
                  >
                    <b-form-group
                      label="Mensagem"
                      label-for="item-name"
                    >
                      <b-form-textarea
                        v-model="item.notifications"
                        rows="3"
                        :state="item.notifications.length <= maxChar"
                        class="char-textarea"
                        :class="item.notifications.length >= maxChar ? 'text-danger' : ''"
                        no-resize
                      />
                      <small
                        class="textarea-counter-value float-right"
                        :class="item.notifications.length >= maxChar ? 'bg-danger' : ''"
                      >
                        <span class="char-count">{{ item.notifications.length }}</span> / {{ maxChar }}
                      </small>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="item.sendPix">
                  <b-col md="12">
                    <div class="demo-inline-spacing">
                      <b-form-radio
                        v-model="pixBool"
                        plain
                        name="some-radios3"
                        :value="false"
                      >
                        Chave gerada no checkout
                      </b-form-radio>
                      <b-form-radio
                        v-model="pixBool"
                        plain
                        name="some-radios3"
                        :value="true"
                        disabled
                      >
                        Chave Personalizada
                      </b-form-radio>
                    </div>
                    <div
                      v-if="pixBool"
                      class="form-inline"
                    >
                      <b-form-input
                        id="chave-pix"
                        v-model="item.pix"
                        placeholder="sua chave"
                      />
                      <b-form-select
                        v-model="item.pixType"
                        label="Tipo da Chave"
                        :options="pixList"
                      />
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="item.sendBoleto">
                  <b-col
                    md="8"
                    class="form-inline"
                  >
                    <b-form-checkbox
                      v-model="item.codeBoleto"
                      :value="true"
                      class="custom-control-primary"
                    >
                      Cód. de barras
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="item.linkBoleto"
                      :value="true"
                      class="custom-control-primary"
                    >
                      acessar boleto
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <b-row v-if="item.sendShipping">
                  <b-col
                    md="8"
                    class="form-inline"
                  >
                    <b-form-radio
                      v-model="item.sendShipping"
                      plain
                      name="some-radios3"
                      :value="true"
                    >
                      link padrão
                    </b-form-radio>
                    &nbsp
                    <b-form-radio
                      v-model="item.sendShipping"
                      plain
                      name="some-radios3"
                      :value="false"
                      disabled
                    >
                      link personalizado
                    </b-form-radio>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    v-if="item.textButton != null"
                    md="8"
                    style="margin-top: -1%;"
                    class="form-inline"
                  >
                    <!-- small -->
                    <b-input-group
                      size="sm"
                      prepend="texto do botão:"
                    >
                      <b-form-input
                        v-model="item.textButton"
                        placeholder="Ver Carrinho"
                      />
                    </b-input-group>

                  </b-col>
                </b-row>

              </b-col>

              <!-- Remove Button -->
              <b-col
                lg="2"
                md="2"
                class="mb-50"
              >
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Deletar</span>
                </b-button>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>
          </b-form>
        </div>

        <!-- primary -->
        <b-dropdown
          id="dropdown-1"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          text="Adicionar"
          variant="primary"
        >
          <b-dropdown-item @click="repeateAgain">
            Nova Mensagem
          </b-dropdown-item>
          <b-dropdown-item
            v-if="selected === 6"
            @click="repeateAgainPix"
          >
            Botão Pix
          </b-dropdown-item>
          <b-dropdown-item
            v-if="selected === 2"
            @click="repeateAgainBoleto"
          >
            Novo botão de Boleto
          </b-dropdown-item>
          <b-dropdown-item
            v-if="status === 4"
            @click="repeateAgainTransporte"
          >
            Novo botão de Transporte
          </b-dropdown-item>
          <b-dropdown-item
            v-if="status === 8"
            @click="repeateAgainCarrinho"
          >
            Botão carrinho
          </b-dropdown-item>
        </b-dropdown>

        <b-button
          variant="success"
          @click="saveNotifications"
        >
          <span>Salvar Mensagens</span>
        </b-button>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BForm, BFormGroup, BRow, BCol, BButton, BFormTextarea, BCard, BOverlay, VBPopover,
  BBadge, BDropdown, BDropdownItem, BFormInput, BFormSelect, BFormCheckbox, BFormRadio,
  BInputGroup,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { codeBasic } from './code'
import { codeCounter } from '../../forms/form-element/form-textarea/code'
import notifications from '../../../functions/basics/notifications.js'

export default {
  name: 'NotificationEdit',
  components: {
    BFormSelect,
    BFormInput,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormTextarea,
    BCard,
    BOverlay,
    vSelect,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BFormRadio,
    BInputGroup,
  },
  directives: {
    VBPopover,
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      pixBool: false,
      pixList: [
        { value: 1, text: 'copia e cola' },
        { value: 2, text: 'aleatória' },
        { value: 3, text: 'CPF/CNPJ' },
        { value: 4, text: 'qrCode' },
      ],
      selected: this.$route.params.paymentId,
      value: '',
      nextTodoId: 2,
      codeBasic,
      maxChar: 500,
      codeCounter,
      items: [],
      lastItems: [],
      uuid: this.$route.params.uuid,
      status: this.$route.params.status,
      show: true,
    }
  },
  async mounted() {
    await this.getNotifications()
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    verifyTags() {

    },
    repeateAgain() {
      this.items.push({
        statusId: 1,
        paymentId: 15,
        notifications: '',
        sendPix: false,
        pixType: null,
        pix: null,
        textLink: null,
        link: null,
        sendBoleto: false,
        linkBoleto: false,
        codeBoleto: false,
        textButton: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    repeateAgainPix() {
      this.items.push({
        statusId: 1,
        paymentId: 15,
        notifications: null,
        sendPix: true,
        pixType: 1,
        pix: null,
        sendBoleto: false,
        linkBoleto: false,
        codeBoleto: false,
        textButton: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    repeateAgainLink() {
      this.items.push({
        statusId: 1,
        paymentId: 15,
        notifications: '',
        pixType: null,
        pix: null,
        textLink: '',
        linkButton: 'asdas',
        sendBoleto: false,
        linkBoleto: false,
        codeBoleto: false,
        textButton: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    repeateAgainBoleto() {
      this.items.push({
        statusId: 1,
        paymentId: 15,
        notifications: '',
        sendPix: false,
        pixType: null,
        pix: null,
        sendBoleto: true,
        linkBoleto: true,
        codeBoleto: true,
        textButton: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    repeateAgainTransporte() {
      this.items.push({
        statusId: 1,
        paymentId: 15,
        notifications: '',
        sendPix: false,
        pixType: null,
        pix: null,
        sendBoleto: false,
        linkBoleto: false,
        codeBoleto: false,
        sendShipping: true,
        textButton: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    repeateAgainCarrinho() {
      this.items.push({
        statusId: 1,
        paymentId: 15,
        notifications: '',
        sendPix: false,
        pixType: null,
        pix: null,
        sendBoleto: false,
        linkBoleto: false,
        codeBoleto: false,
        sendShipping: false,
        textButton: 'Ver Carrinho',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    async getNotifications() {
      let payment

      if (this.status === 2) {
        payment = this.selected
      } else if (this.status === 8) {
        payment = 1
      } else {
        payment = 19
      }
      const messages = await notifications.getNotifications(this.status, payment, this.uuid)
      this.lastItems = messages
      messages.forEach(message => {
        message.notifications = message.notifications ? decodeURIComponent(message.notifications) : null
      })
      this.items = messages
      console.log(this.items)
      this.show = false
    },
    async saveNotifications() {
      let payment
      this.show = true

      if (this.status === 2) {
        payment = this.selected
      } else if (this.status === 8) {
        payment = 1
      } else {
        payment = 19
      }
      await notifications.deleteNotification(this.status, payment, this.uuid)
      await notifications.createNotification(Number(this.status), payment, this.uuid, this.items)
      // for (const notification of this.items) {
      //   await notifications.createNotification(Number(this.status), payment, this.uuid, encodeURIComponent((notification.notifications)))
      // }
      this.show = false
      this.$swal({
        title: 'Salvo!',
        text: 'Suas notificações foram editadas com sucesso.',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
      this.$router.push({ name: 'notifications-status' })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
